exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Cy94BtAlCk5yd04TjX5LC{display:inline-block;background:#6982ff;color:#fff;font-size:13px;padding:7px 10px;border-radius:2px;margin-right:10px}\n", ""]);

// Exports
exports.locals = {
	"Chip": "_2Cy94BtAlCk5yd04TjX5LC"
};